import React, { useState } from 'react';
import { Layers, Plus, Trash2, ShieldCheck, Zap } from 'lucide-react';

export default function StrategyBuilder() {
  const [strategyName, setStrategyName] = useState('Nifty Bull Call Spread');
  const [legs, setLegs] = useState([
    { id: 1, strike: 24300, type: 'CE', action: 'BUY', qty: 50, price: 155.50 },
    { id: 2, strike: 24500, type: 'CE', action: 'SELL', qty: 50, price: 65.00 }
  ]);

  const [newStrike, setNewStrike] = useState(24400);
  const [newType, setNewType] = useState('CE');
  const [newAction, setNewAction] = useState('BUY');
  const [newQty, setNewQty] = useState(50);
  const [newPrice, setNewPrice] = useState(110.00);

  const addLeg = (e) => {
    e.preventDefault();
    const leg = {
      id: Date.now(),
      strike: parseInt(newStrike),
      type: newType,
      action: newAction,
      qty: parseInt(newQty),
      price: parseFloat(newPrice)
    };
    setLegs([...legs, leg]);
  };

  const removeLeg = (id) => {
    setLegs(legs.filter(l => l.id !== id));
  };

  // Calculate approximate net debit / credit
  let netPremium = 0;
  legs.forEach(l => {
    if (l.action === 'BUY') {
      netPremium -= l.price * l.qty;
    } else {
      netPremium += l.price * l.qty;
    }
  });

  return (
    <div style={{ padding: '30px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', sans-serif", boxSizing: 'border-box', overflowY: 'auto' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '15px' }}>
        <div>
          <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '26px', color: 'var(--vyodha-gold)', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Layers size={28} /> Institutional Options Strategy Builder
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '13px', margin: '5px 0 0 0' }}>Build, analyze, and deploy custom multi-leg options spreads instantly.</p>
        </div>

        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input 
            type="text" 
            value={strategyName} 
            onChange={(e) => setStrategyName(e.target.value)}
            style={{ backgroundColor: 'var(--bg-panel)', color: 'var(--vyodha-gold)', border: '1px solid #D4AF37', padding: '10px 15px', borderRadius: '10px', fontWeight: 'bold', outline: 'none' }} 
          />
          <button onClick={() => alert(`Strategy "${strategyName}" successfully deployed to basket!`)} style={{ backgroundColor: '#10B981', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Zap size={16} /> Deploy Basket
          </button>
        </div>
      </div>

      {/* Grid Layout */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
        
        {/* Left: Add Leg Form */}
        <div style={{ backgroundColor: 'var(--bg-panel)', padding: '25px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
          <h3 style={{ color: 'var(--vyodha-gold)', fontSize: '18px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Plus size={20} /> Add Strategy Leg
          </h3>

          <form onSubmit={addLeg} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>Action</label>
                <select value={newAction} onChange={(e) => setNewAction(e.target.value)} style={{ width: '100%', padding: '10px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '8px', outline: 'none' }}>
                  <option value="BUY">BUY</option>
                  <option value="SELL">SELL</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>Type</label>
                <select value={newType} onChange={(e) => setNewType(e.target.value)} style={{ width: '100%', padding: '10px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '8px', outline: 'none' }}>
                  <option value="CE">CALL (CE)</option>
                  <option value="PE">PUT (PE)</option>
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>Strike Price</label>
                <input type="number" value={newStrike} onChange={(e) => setNewStrike(e.target.value)} style={{ width: '100%', padding: '10px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '8px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>Quantity</label>
                <input type="number" value={newQty} onChange={(e) => setNewQty(e.target.value)} style={{ width: '100%', padding: '10px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '8px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div>
              <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>Estimated Price (₹)</label>
              <input type="number" step="0.05" value={newPrice} onChange={(e) => setNewPrice(e.target.value)} style={{ width: '100%', padding: '10px', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '8px', outline: 'none', boxSizing: 'border-box' }} />
            </div>

            <button type="submit" style={{ backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' }}>
              Add Leg to Strategy
            </button>
          </form>
        </div>

        {/* Right: Legs Table & Payoff Overview */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ backgroundColor: 'var(--bg-panel)', padding: '25px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
            <h3 style={{ color: 'var(--vyodha-gold)', fontSize: '18px', marginBottom: '15px' }}>Strategy Legs ({legs.length})</h3>
            
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
                <thead>
                  <tr style={{ color: 'var(--text-muted)', borderBottom: '1px solid var(--border-color)' }}>
                    <th style={{ padding: '8px' }}>Action</th>
                    <th>Strike & Type</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {legs.map(l => (
                    <tr key={l.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                      <td style={{ padding: '10px', color: l.action === 'BUY' ? '#10B981' : '#EF4444', fontWeight: 'bold' }}>{l.action}</td>
                      <td style={{ padding: '10px' }}>{l.strike} {l.type}</td>
                      <td style={{ padding: '10px' }}>{l.qty}</td>
                      <td style={{ padding: '10px' }}>₹ {l.price}</td>
                      <td style={{ padding: '10px' }}>
                        <button onClick={() => removeLeg(l.id)} style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer' }}><Trash2 size={16} /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={{ backgroundColor: 'var(--bg-panel)', padding: '20px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ color: 'var(--vyodha-gold)', fontSize: '14px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <ShieldCheck size={18} /> Payoff & Margin Overview
            </h4>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
              <span style={{ color: 'var(--text-muted)' }}>Net Premium Required:</span>
              <strong style={{ color: netPremium <= 0 ? '#10B981' : '#EF4444' }}>₹ {netPremium.toFixed(2)} ({netPremium <= 0 ? 'Net Debit' : 'Net Credit'})</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
              <span style={{ color: 'var(--text-muted)' }}>Max Risk / Reward:</span>
              <strong style={{ color: '#38BDF8' }}>Defined Risk Strategy</strong>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}